"use client";

import { useSearchParams } from "next/navigation";
import { useState } from "react";

import { APP_NAME } from "@calcom/lib/constants";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import { Button } from "@calcom/ui/components/button";
import { EmailField } from "@calcom/ui/components/form";

/** "Sign in with your company SSO": the e-mail domain picks the organization's identity provider. */
export default function SsoLoginView() {
  const { t } = useLocale();
  const searchParams = useSearchParams();
  const error = searchParams?.get("error");
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(false);

  return (
    <div className="bg-default/80 flex min-h-screen items-center justify-center px-4 py-10">
      <div className="border-subtle bg-default w-full max-w-md rounded-xl border p-10 shadow-sm">
        <div className="mb-6 text-center">
          <img src="/calify-logo.svg" alt={APP_NAME} className="mx-auto h-9 w-auto dark:hidden" />
          <img src="/calify-logo-white.svg" alt={APP_NAME} className="mx-auto hidden h-9 w-auto dark:block" />
          <p className="text-subtle mt-3 text-sm">{t("sso_login_intro")}</p>
        </div>
        {error && <p className="bg-error text-error mb-4 rounded-md p-3 text-sm">{t(error)}</p>}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setPending(true);
            window.location.href = `/api/sso/oidc/start?email=${encodeURIComponent(email.trim())}`;
          }}>
          <EmailField
            label={t("email_address")}
            value={email}
            required
            autoFocus
            placeholder="prenom@entreprise.fr"
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" className="mt-6 w-full justify-center" loading={pending}>
            {t("sso_continue")}
          </Button>
        </form>
        <a href="/auth/login" className="text-subtle mt-6 block text-center text-sm hover:underline">
          {t("sso_back_to_login")}
        </a>
      </div>
    </div>
  );
}
